import { UserInteractionStatus } from '../types/userInteraction';
import { CivicPassMessageAction } from '../types/civicPass';
import { GatewayCoreState } from '../types/gatewayCore';

export const getUserInteractionStatusFromAction = (
  state: GatewayCoreState,
  action: CivicPassMessageAction
): UserInteractionStatus | null => {
  if (
    // these actions don't have any follow-on flow so they represent a finished flow
    [
      CivicPassMessageAction.TOKEN_ACTIVE,
      CivicPassMessageAction.TOKEN_REVOKED,
      CivicPassMessageAction.TOKEN_FROZEN,
      CivicPassMessageAction.TOKEN_REJECTED,
      CivicPassMessageAction.FAILED_IP_CHECK,
      CivicPassMessageAction.FAILED_VPN_CHECK,
      CivicPassMessageAction.ERROR,
    ].includes(action)
  ) {
    return UserInteractionStatus.FINISHED;
  }
  return state.internal?.userInteraction?.status;
};
